<template>
    <div class="TTL-select" :style="{width:option.width}">
        <el-cascader 
            v-model="selectvalue" 
            :options="list"
            :placeholder="option.placeholder" 
            :filterable="option.filterable" 
            :clearable="option.clearable"
            @change="changeData"
        />
    </div>
</template>

<script>
export default {
  props: ['value','list','option'],
  data() {
      return {
          selectvalue: this.value,
          selectlist: this.list,
          option: {
              placeholder:this.option && this.option.placeholder ? this.option.placeholder : '请选择城市',      //空数据提示语
              clearable: this.option && this.option.clearable ? this.option.clearable : false,                 //是否有清空数据项
              filterable: this.option && this.option.filterable ? this.option.filterable : false,              //是否有搜索数据项
              width: this.option && this.option.width ? this.option.width+'px' : '220px',                      //选择框宽度
          },
      }
  },

  watch: {

      value(val) {
          this.selectvalue=val;
      },

      list(val) {
          this.selectlist=val;
      },
      
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      changeData() {
        var datavalue=this.selectvalue;
        var result={cityinfo:datavalue};
        this.$emit('finish',result);
      },

  }

}
</script>

<style scoped>
.TTL-select .el-select {width:100%}
::v-deep(.el-cascader-node__label) {font-size:13px !important;}
</style>